
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PoStatusMstApi } from '../../api/master/postatus-mst.api';
import { PoStatusMst, PoStatusMstData } from '../../interface/master/postatus-mst';

@Injectable()
export class PoStatusMstService extends PoStatusMstData {

  constructor(private api: PoStatusMstApi) {
    super();
  }
  list(url: string): Observable<PoStatusMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<PoStatusMst>{
      return this.api.getById(url);
  }
  create(url: string, data:PoStatusMst): Observable<PoStatusMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:PoStatusMst): Observable<PoStatusMst> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
